import { render, staticRenderFns } from "./propagandahsy.vue?vue&type=template&id=6f104d68&"
import script from "./propagandahsy.vue?vue&type=script&lang=js&"
export * from "./propagandahsy.vue?vue&type=script&lang=js&"
import style0 from "./propagandahsy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports